/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------
//------------------------------------------------------------
// LOGOUT
//------------------------------------------------------------

const LOGOUT = (state) => {
    state.loggedIn = false;
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	LOGOUT
};